import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";

import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepSpecific from "../../../../../../hooks/useStepSpecific";
import React from "react";
import { createFormalValidationFromSchema } from "../../../../../../yup/utils/yupUtils";
import { createAdditionalDocDetailsValidationSchemas } from "../../../../../../yup/additionalDoc/AdditionalDocDetailsValidationSchemas";
import {
  completeAdditionalDocDetailStep,
  setStepAdditionalDocDetailEdited,
} from "../../../../../../store/redux/slice/Forms/libservAdditionalDocForm";
import AdditionalDocStepDetails from "./AdditionalDocStepDetails";
import { initialLibservAdditionalDocApplication } from "../../../../../../init/libservAdditionalDocInitialValues";

const LibservAdditionalDocStepDetails = () => {
  const libservAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.LibservAdditionalDocForm;
  });

  const fullSchema = createAdditionalDocDetailsValidationSchemas;
  const formalSchema = createFormalValidationFromSchema(fullSchema);

  const { onSubmit, methods } = useStepSpecific(
    libservAdditionalDocForm.additionalDocDetail,
    libservAdditionalDocForm.id,
    baseEndpointPaths.libservAdditionalDoc,
    formalSchema,
    setStepAdditionalDocDetailEdited,
    completeAdditionalDocDetailStep,
    initialLibservAdditionalDocApplication,
  );

  useFormReset("LIBSERV_ADDITIONAL_DOCUMENTS", libservAdditionalDocForm.additionalDocDetail, methods.reset);

  return (
    <AdditionalDocStepDetails
      fullSchema={fullSchema}
      formalSchema={formalSchema}
      methods={methods}
      onSubmit={onSubmit}
    />
  );
};
export default LibservAdditionalDocStepDetails;
